export class Alert {
  type: AlertType;
  message: string;
}

export type AlertType = 'success' | 'danger' | 'info' | 'warning';
